/**
 * הערכים של תבנית צ'קליסט, כפי שהחלון עובד איתם.
 *
 * בקובץ נפרד מהרכיב כדי שקובץ של רכיב ייצא רכיבים בלבד.
 */
export type Recurrence = 'daily' | 'weekly' | 'monthly' | 'once';

/** משימה בתוך התבנית. בלי id = עוד לא נשמרה. */
export type TemplateItemValue = {
  id?: string;
  text: string;
  requires_photo: boolean;
};

export type TemplateValues = {
  id: string | null;
  name: string;
  branchIds: string[];
  recurrence: Recurrence;
  weekdays: number[];
  dayOfMonth: number | null;
  onDate: string | null;
  dueTime: string | null;
  items: TemplateItemValue[];
};

export const EMPTY_TEMPLATE: TemplateValues = {
  id: null,
  name: '',
  branchIds: [],
  recurrence: 'daily',
  weekdays: [],
  dayOfMonth: null,
  onDate: null,
  dueTime: null,
  items: [],
};

export const RECURRENCE_LABEL: Record<Recurrence, string> = {
  daily: 'כל יום',
  weekly: 'בימים קבועים בשבוע',
  monthly: 'פעם בחודש',
  once: 'תאריך אחד',
};

/** "כל הסניפים" או שמות הסניפים, לשורה ברשימה. */
export function branchesLabel(template: {
  checklist_template_branches: { branches: { name: string } | null }[];
}): string {
  const names = template.checklist_template_branches
    .map((one) => one.branches?.name)
    .filter((name): name is string => Boolean(name));

  return names.length === 0 ? 'כל הסניפים' : names.join(', ');
}

/** "כל יום", "ראשון, רביעי", "ב 31 לחודש", "22.10.2026". */
export function recurrenceLabel(
  template: {
    recurrence: Recurrence;
    weekdays: number[] | null;
    day_of_month: number | null;
    on_date: string | null;
  },
  weekdayNames: readonly string[],
): string {
  switch (template.recurrence) {
    case 'weekly': {
      const days = (template.weekdays ?? []).map((day) => weekdayNames[day]).filter(Boolean);
      return days.length > 0 ? days.join(', ') : 'בימים קבועים';
    }
    case 'monthly':
      return template.day_of_month ? `ב ${template.day_of_month} לחודש` : 'פעם בחודש';
    case 'once':
      return template.on_date ?? 'תאריך אחד';
    default:
      return 'כל יום';
  }
}
